export default __webpack_public_path__ + "static/media/lavawall.60bcf288.png";